export const de_DE = {
  translation: {
    add_to_cart: "Artikel in den Warenkorb legen",
    save: "Speichern",
    load: "Artikel laden",
    title: "Konfiguration",
    type_key: "Typenschlüssel",
    start: "Start",
    generate_document: "Datenblatt erstellen",
    sap_button: "Artikel in SAP anlegen",
    cad_button: "CAD-Daten erstellen",
    drawing_button: "Zeichnungsdaten erstellen",
    reset_configuration: "Konfiguration zurücksetzen",
    show_additional_information: "Weitere Informationen anzeigen",
    sap_title: "SAP",
    close_configuration_button: "Schließen",
    no_results_found: "Keine Ergebnisse gefunden",
    load_configuration_dialog: {
      title: "Konfiguration laden – Suchparameter festlegen",
      cancel: "Abbrechen",
      search: "Suchen",
      start_date: "Erstelldatum von",
      end_date: "bis",
      guid: "GUID",
      material_number: "Materialnummer",
      order_code: "Bestellcode",
      creator: "Ersteller",
      description: "Beschreibung",
      info_artikel: "Info-Artikel",
      short_text: "Kurztext",
      version: "Version",
      status: "Status",
      update_user: "Geändert von",
      createdDate: "Erstelldatum",
      saved_records: "Gespeicherte Datensätze",
      back: "Zurück",
      open: "Öffnen",
      rows_per_page: "Zeilen pro Seite:",
    },
    error: {
      ERROR_LOAD_DATA_ERROR:
        "(LADEN) fehlgeschlagen (Daten inkorrekt oder unvollständig)",
      ERROR_SAVE_DATA_ERROR:
        "(SPEICHERN) fehlgeschlagen (Daten inkorrekt oder unvollständig)",
      ERROR_LOAD_ID: "ID zum Laden nicht gefunden",
      ERROR_LOAD_ID_CONFIG: "Fehler vom Konfigurator beim Laden eines Projekts",
      ERROR_LOADSTART_CONFIG: "Fehler vom Konfigurator beim Start",
      ERROR_MISSING_VALUES:
        "Allgemeine Fehlermeldung, wenn die Validierung der Frontend-Daten fehlschlägt",
      ERROR_COOKIE_SERVICE_INITIAL:
        "Cookie-Service-Initialisierung fehlgeschlagen",
      ERROR_COOKIE_GENERAL: "Fehler im Cookie-Service",
      ERROR_TOKEN_NOT_FOUND: "Token nicht gefunden",
      ERROR_ID_BLOCKED: "Artikel wird bearbeitet, Änderungen nicht möglich",
      ERROR_DB_SAVE: "Fehler beim Speichern der Daten in die Datenbank",
      ERROR_LOAD_VALID:
        "Laden der Konfiguration fehlgeschlagen, Daten ungültig",
      ERROR_NONE_LOAD_ID_FOUND_SAP_CHECK:
        "ID wurde nicht gefunden, SAP-Check fehlgeschlagen",
      ERROR_NONE_LOAD_ID_FOUND_ROWID_FROM_SHOPID:
        "Keine Materialnummer gefunden für die ID aus der Shop-ID",
      ERROR_DELETE_CONFIGURATION: "Fehler beim Löschen der Konfiguration",
      ERROR_DEFINITION_SECRET_JWT: "JWT-Definition fehlt",
      ERROR_PATH_NOT_DEFINED: "Pfad nicht definiert",
      ERROR_BACKLINK_URL: "Backlink-URL nicht definiert",
      ERROR_POSITIONDATA_EMPTY: "Positionsdaten sind leer",
      ERROR_SHOP_ID: "Shop-ID nicht gefunden",
      ERROR_CADBOXDATA_EMPTY: "Keine CAD-Box-Daten gefunden",
      ERROR_NONE_LOAD_ID_FOUND: "Keine ID zum Laden gefunden",
      ERROR_NONE_ACCEPTABLE_ID: "Keine akzeptable ID gefunden",
    },
    sap: {
      create_error: "Fehler beim Anlegen",
      create_success: "Erfolgreich angelegt",
    },
    button: {
      save: "Speichern",
      cancel: "Abbrechen",
    },
  },
};

export default de_DE;
